import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMotionBudget } from '../../app/hooks/useMotionBudget';
interface XPGainAnimationProps {
  amount: number;
  onComplete?: () => void;
  className?: string;
}
export function XPGainAnimation({
  amount,
  onComplete,
  className = ''
}: XPGainAnimationProps) {
  const {
    shouldAnimate
  } = useMotionBudget();
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (!shouldAnimate) {
      setIsVisible(false);
      onComplete?.();
      return;
    }
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete?.();
    }, 1500); // matches animation duration
    return () => clearTimeout(timer);
  }, [shouldAnimate, onComplete]);
  if (!shouldAnimate) return null;
  return <AnimatePresence data-id="element-2402">
      {isVisible && <motion.div className={`absolute pointer-events-none z-50 flex items-center justify-center ${className}`} initial={{
      opacity: 0,
      y: 0,
      scale: 0.5
    }} animate={{
      opacity: [0, 1, 1, 0],
      y: -60,
      scale: [0.5, 1.2, 1, 1]
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 1.5,
      ease: 'easeOut',
      times: [0, 0.2, 0.8, 1]
    }} data-id="element-2403">
          <div className="bg-orange-500 text-white font-black px-3 py-1 rounded-full shadow-lg border-2 border-white flex items-center gap-1" data-id="element-2404">
            <span className="text-lg" data-id="element-2405">+{amount}</span>
            <span className="text-xs uppercase tracking-wider" data-id="element-2406">XP</span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}